import React from "react"
// eslint-disable-next-line
import { Route, Routes } from "react-router-dom"
import { basename } from "../path-util"
import TitleRoute from "../scenes/drive/components/TitleRoute"
import { capitalize } from "@mui/material/utils"

interface ITitleChangerProps {
    validPaths?: string[]
}

export default function TitleChanger({ validPaths = [] }: ITitleChangerProps) {
    return (
        <Routes>
            <Route
                path={"/@hosting/:prefix/*"}
                element={
                    <TitleRoute
                        path={"/@hosting/:prefix/*"}
                        mapper={(prefix) =>
                            `${
                                prefix
                                    ? decodeURIComponent(basename(prefix)) +
                                      " - "
                                    : ""
                            }@hosting - Ortery Cloud`
                        }
                    />
                }
            />
            <Route
                path="/plan/invoice"
                element={
                    <TitleRoute
                        path="/plan/invoice"
                        mapper={() => "Invoice - Plan - Ortery Cloud"}
                    />
                }
            />
            {validPaths.map((p) => (
                <Route
                    key={p}
                    path={`/${p}`}
                    element={
                        <TitleRoute
                            path={`/${p}`}
                            mapper={() =>
                                `${p
                                    .split("-")
                                    .map(capitalize)
                                    .join(" ")} - Ortery Cloud`
                            }
                        />
                    }
                />
            ))}
            <Route
                path="/plan/invoice"
                element={<TitleRoute mapper={() => "Ortery Cloud"} />}
            />
        </Routes>
    )
}
